module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zjrm"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(i) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#/search/keywordSearch?id=' + i.sort
      },
      domProps: {
        "textContent": _vm._s(i.keyword)
      }
    })])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("最近热门")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f234e9b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/hotSearch.vue
// module id = 256
// module chunks = 0